import { mapSelectionsOdds } from "../mapSelectionsOdds";
export const mapMarketsSelectionsOdds = (markets, oddStyle, dict) => {
    return markets.map((market) => {
        market.selections = mapSelectionsOdds(market.selections, oddStyle, dict);
        return market;
    });
};
//# sourceMappingURL=mapMarketsSelectionsOdds.js.map